// extracted by css-extract-rspack-plugin
export default {"cls1":"NavImpactStats-cls1_726","cls2":"NavImpactStats-cls2_4RL NavImpactStats-cls1_726","isMobileNav":"NavImpactStats-isMobileNav_J5A"};